import { baseApi } from 'api/baseApi';
import { invalidateTagsByResponseId } from '../../JobResults/utils/jobUtil';

export type UploadObjectsResult = {
  id: string;
  objectCount: number;
  foundColumns: Array<{
    cell: string;
    attribute?: string;
    field?: string;
    availabilityRelation?: string;
  }>;
  warnings: Array<{ cell?: string; column?: string; message: string }>;
  exampleRows: Array<Array<string>>;
  detectedSeparator?: string | null;
};

export const importObjectsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    uploadObjectsFile: build.mutation<UploadObjectsResult, FormData>({
      query: (formData) => ({
        url: '/objects/batch-operations/jobs/batch-import',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: invalidateTagsByResponseId,
    }),
    queueImportJob: build.mutation<
      { id: string },
      {
        jobId: string;
        separator: string;
        multiOperationType: 'add' | 'replace';
      }
    >({
      query: ({ jobId, separator, multiOperationType }) => ({
        url: `/objects/batch-operations/jobs/batch-import/${jobId}/queue`,
        method: 'POST',
        body: {
          separator,
          multiOperationType,
        },
      }),
      transformResponse: (_response, _meta, arg) => {
        return { id: arg.jobId };
      },
      invalidatesTags: invalidateTagsByResponseId,
    }),
    approveImportJob: build.mutation<{ id: string }, { jobId: string }>({
      query: ({ jobId }) => ({
        url: `/objects/batch-operations/jobs/batch-import/${jobId}/approve`,
        method: 'POST',
      }),
      transformResponse: (_response, _meta, arg) => {
        return { id: arg.jobId };
      },
      invalidatesTags: invalidateTagsByResponseId,
    }),
  }),
});

export const {
  useUploadObjectsFileMutation,
  useQueueImportJobMutation,
  useApproveImportJobMutation,
} = importObjectsApi;
